export const opcionesMenu = [
  {
    namePath: "/",
    texto: "Inicio",
  },
  {
    namePath: "/jornada-investigacion",
    texto: "Jornadas de Investigación",
  },
  {
    namePath: "/acerca-de",
    texto: "Acerca de nosotros",
  },
  {
    namePath: "/normativas",
    texto: "Normativas",
  },
  {
    namePath: "/contacto",
    texto: "Contacto",
  },
];
